import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-credential-dialog',
  templateUrl: './credential-dialog.component.html',
  styleUrls: ['./credential-dialog.component.scss']
})
export class CredentialDialogComponent implements OnInit {
    username = '';
    password = '';
    submitted = false;
  constructor() { }
    @Output() onSubmit = new EventEmitter<{ username: string, password: string }>();
    @Output() onCancel = new EventEmitter();

   

    ngOnInit(): void {
        
  }
    submit() {
        this.submitted = true;
        if (!this.username || this.username.trim() === '' || !this.password || this.password.trim() === '') {
            return; // Do not proceed if fields are empty
        }
        this.onSubmit.emit({ username: this.username, password: this.password });
    }
}
